export default "__VITE_ASSET__db351e4d__"